import TYPES from 'Catalog/types';

export const selectOrderBy = item => ({
  type: TYPES.SELECT_ORDERBY,
  payload: { item },
});

export const setDefaultOrderBy = () => ({
  type: TYPES.SET_DEFAULT_ORDERBY,
});
